import fireSaveForLaterAnalytics from "../analytics/saveForLater";
import getSdks from "./sdks";
import { logError, ERROR_TYPE } from "./newRelicLogger";
import sendBeacon from "./sendBeacon";

interface SaveForLaterParams {
  product: { id: number };
  items: Array<{
    productId: number;
    variantId?: number;
    colourWayId?: number;
  }>;
  pageArea?: unknown; //TODO: make this mandatory on the analytics ticket
  looksProducts?: unknown[];
}

interface SavedSDK {
  savedItems: Promise<{
    addItems: (args: { items: SaveForLaterParams["items"] }) => Promise<void>;
  }>;
}

const saveForLater = async ({
  product,
  items,
  pageArea,
  looksProducts,
}: SaveForLaterParams) => {
  try {
    const savedSdk = await getSdks();
    const savedItemsSdk = await (savedSdk as SavedSDK).savedItems;
    await savedItemsSdk.addItems({ items });
    fireSaveForLaterAnalytics(product, pageArea, looksProducts);
    sendBeacon(product.id, "onWishlistBeacon");
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : String(error);

    logError(ERROR_TYPE.UserActionFailed, {
      action: "SaveForLater",
      message: errorMessage,
    });
  }
};

export default saveForLater;
